import { NavPage } from "../../services/NavService";
import { EditorNav } from "../EditorNav/EditorNav";
import { TopNav } from "../TopNav/TopNav";
import "../../style/editor.scss";
import "./ProductLineEditor.scss";
import { EditorContext } from "../EditorCommon/EditorContext";
import { useContext } from "react";
import { Card } from "react-bootstrap";

export function ProductLineEditor() {
    const ec = useContext(EditorContext);
    const selectProductLine = async (id: number) => {
        const result = await ec.cabinetService.setProductLine(id);
        if (result.success) {
            ec.navService.navigateNext(NavPage.ProductLine,true);
        }
    };

    const productLines = ec.cabinetService.chainInfo.productLines.map(pl => {
        const border = pl.id === ec.cabinet.productLineId ? "primary" : undefined;
        return (
            <Card border={border}
                onClick={() => selectProductLine(pl.id)}
                key={pl.id}
            >
                {pl.imageUrl && <Card.Img variant="top" src={pl.imageUrl} />}
                <Card.Body>
                    <Card.Title>{pl.name}</Card.Title>
                    {pl.description && <Card.Text style={{ whiteSpace: "pre-line" }}>
                        {pl.description}
                    </Card.Text>}
                </Card.Body>
            </Card>
        )
    });

    return (
        <div className="editor product-line-editor">
            <TopNav header={ec.translator("product line editor header", "Produktlinje")}/>

            <div className="main-editor">
                <div className="box-container">
                    {productLines}
                </div>
            </div>

            <EditorNav currentPage={NavPage.ProductLine} />
        </div>
    );
}
